import React, {useState,useEffect} from "react";
import {EtTable} from "../shared/table/table";
import {axiosInstance} from "../../config/apiTemplate";
import CircularProgress from '@mui/material/CircularProgress';

export default function InterestLog(props){

    const [logs,setLogs] = useState([]);
    const [response, setResponse] = useState([]);
    const [isLoading, setLoading] = useState(true);

    useEffect(()=>{
        document.title = "EPM - Interest Recycle Bin";

        setLoading(true);
        getLogs();

        return () =>{
            setLoading(false);  
        }
    },[props.trading_id,props.ts]);

    async function getLogs(){
        let headerForm = new FormData();
  
        headerForm.append("t_id", props.trading_id);
        const url = "api/bin/intlog.php";
    
        try {
          const response = await axiosInstance.post(url, headerForm);
          if (response.data.statusCode === 201) {
            let logs = response.data.logs;
            setLogs(logs);
            setResponse(response.data);
          }else if(response.data.statusCode === 500){
            getLogs();
          }
         setLoading(false);
        } catch (e) {
          console.log(e);
          setLoading(false);
        }
    }

    function renderLoading(){
        return(
            <div className="text-center">
                <CircularProgress />
                <p>Fetching Data...</p>
            </div>
        )
    }

    async function deleteLog(id){
        let resp = window.confirm("Are you sure to recover this log entry?");
        if(resp){
            //delete log
        }
    }

    return(
        <div className="container-fluid pt-3">
            <div className="row">
                <div className="col">
                    <div className="card card-body">
                    {isLoading ?renderLoading():<div className="container-fluid">
                            <br/>
                            <EtTable 
                                data={logs}
                                sortable={true}
                                headers={[
                                    {display:"No",sort:"no"},
                                    {display:"Period From",sort:"periodFrom_clean",style:{minWidth:140}},
                                    {display:"Period To",sort:"periodTo_clean",style:{minWidth:140}},
                                    {display:"Date Received",sort:"dateReceived_clean",style:{minWidth:140}},
                                    {display:"Interest Received",sort:"intReceived_clean",style:{minWidth:140}},
                                    {display:"Remarks",sort:"remarks",style:{minWidth:200}},
                                    {display:"Recover",sort:"remove"},
                                ]}
                                displayFieldKeys={[
                                    {key:"no"},
                                    {key:"periodFrom"},
                                    {key:"periodTo"},
                                    {key:"dateReceived"},
                                    {key:"intReceived",prepend:"RM "},
                                    {key:"remarks"},
                                    {key:"remove",style:{"fontWeight":"bold",color:"green"},isClickable:true,clickAction:deleteLog,clickProp:{"token":"removeToken"}},
                                ]}
                                showPagination={true}
                            />
                        </div>}
                    </div>
                </div>
            </div>
        </div>
    );


}